export default __webpack_public_path__ + "static/media/uploader-abbottLibre-1.3a1b6ff2.png";